<ion-card class="card-grey" [class.viewMinimal]="displayMode === 'slider_minimal'" [class.ghost]="ghostMode">
    <ion-card-content [class.viewMinimal]="displayMode === 'slider_minimal'">
        <div *ngIf="displayMode === 'list'">
            <ng-container *ngFor="let plugType of plugTypes; trackBy: trackByName">
                <ion-item (click)="selectPlugType(plugType)"
                          [class.selected]="isSelected(plugType)"
                          tappable
                          class="plugPath plug">
                    <ion-thumbnail slot="start" class="plug-style" [class.plugSelected]="isSelected(plugType)">
                        <remote-img [src]="'/api/download/' + plugType.iconRef"
                                    [alt]="''"
                                    [ghostClass]="'round'"
                                    *ngIf="plugType.iconRef"
                        ></remote-img>
                    </ion-thumbnail>
                    <ion-icon class="flashIcon ghost-hidden" name="flash" *ngIf="!plugType.iconRef"></ion-icon>

                    <ion-label class="plug-label medium-ghost-size">
                        <span class="ghost-hidden">{{'plugType.' + plugType.name | translate}}</span></ion-label>
                </ion-item>

                <div *ngIf="maybeNeedCable && isSelected(plugType)">
                    <ion-item class="cableInfo">
                        <ion-label class="cableInfo-label">{{'charge.plugTypeChoice.hasCable' | translate}}
                        </ion-label>
                        <ion-toggle class="cableInfo-toggle" color="primary" [(ngModel)]="hasPlugCable"
                                    name="hasCable"></ion-toggle>
                    </ion-item>
                </div>


                <div *ngIf="!noCableNeeded && !maybeNeedCable && isSelected(plugType)">
                    <ion-item class="cableInfo">
                        <ion-label class="cableInfo-label">
                            {{'charge.plugTypeChoice.dontForgetCable' | translate}}
                        </ion-label>
                    </ion-item>
                </div>
            </ng-container>
        </div>

        <div *ngIf="(displayMode === 'slider' || displayMode === 'slider_minimal') && plugTypes" class="plugSlider">
            <h5>{{'charge.plugTypeChoice.sliderTitle' | translate}}</h5>

            <izivia-slides
                    [pagination]="plugTypes.length > nbPlugsPerSlide">
                <izivia-slide *ngFor="let plugTypeChunk of chunk(plugTypes, nbPlugsPerSlide); trackBy: trackByIndex">
                    <ng-template iziviaSlideTemplate>
                        <div *ngFor="let plugType of plugTypeChunk; trackBy: trackByName"
                             tappable
                             (click)="selectPlugType(plugType)"
                             class="plugSlider-content">
                            <div>
                                <ion-thumbnail slot="start" class="plugSlider-content-style ghost-height"
                                               [class.selected]="isSelected(plugType)">
                                    <remote-img *ngIf="plugType.iconRef"
                                                [src]="'/api/download/' + plugType.iconRef"
                                                [alt]="''"
                                                class="ghost-hidden"></remote-img>
                                </ion-thumbnail>
                            </div>

                            <ion-icon name="flash" class="ghost-hidden" *ngIf="!plugType.iconRef"></ion-icon>

                            <div>
                                <ion-label class="plugSlider-content-label medium-ghost-size">
                                    <span class="ghost-hidden">{{'plugType.' + plugType.name | translate}}</span>
                                </ion-label>
                            </div>
                        </div>
                    </ng-template>
                </izivia-slide>
            </izivia-slides>

            <div *ngIf="maybeNeedCable">
                <ion-item class="cableInfoSlider">
                    <ion-label class="cableInfoSlider-label">{{'charge.plugTypeChoice.hasCable' | translate}}
                    </ion-label>
                    <ion-toggle class="cableInfoSlider-toggle" color="primary" [(ngModel)]="hasPlugCable"
                                name="hasCable"></ion-toggle>
                </ion-item>
            </div>

            <div *ngIf="!noCableNeeded && !maybeNeedCable">
                <ion-item class="cableInfoSlider">
                    <ion-label class="cableInfoSlider-label">
                        {{'charge.plugTypeChoice.dontForgetCable' | translate}}
                    </ion-label>
                </ion-item>
            </div>
        </div>
    </ion-card-content>
</ion-card>
